import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import Field from '../../../../../../components/Form/Field'
import InstagramAccountCheckbox from './InstagramAccountCheckbox'

import { formatOptionsList } from '../../../../../../features/formatters'

import {
  clearAccessibleSocialPages,
  clearFacebookPages,
  getAccessibleSocialPages,
  getFacebookPages
} from '../../../../../../modules/actions/socialAccounts'
import {
  accessibleSocialPagesIsLoadingSelector,
  accessibleSocialPagesSelector
} from '../../../../../../modules/selectors/socialAccounts'
import { getCurrentUserSelector } from '../../../../../../modules/selectors/app'

import { SOCIAL_MEDIA_POST } from '../../fields'
import { FACEBOOK_PROVIDER_PLATFORM } from '../../../../../../constants/selectLists/platformList'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'

function SocialMediaAccountsSection({ formik }) {
  const dispatch = useDispatch()
  const drawerFormClasses = useDrawerFormStyles()

  const { facebook_is_connected: facebookIsConnected } = useSelector(getCurrentUserSelector)

  const accessibleSocialPages = useSelector(accessibleSocialPagesSelector)
  const accessibleSocialPagesIsLoading = useSelector(accessibleSocialPagesIsLoadingSelector)

  const formattedFacebookPages = formatOptionsList({
    list: accessibleSocialPages,
    valueName: 'external_id',
    labelName: 'name'
  })

  const { t } = useTranslation()

  useEffect(() => {
    // We use accessiblePages "api/pages" point to show pages, but to get instagram account we must use "api/facebook/pages"
    // Only "api/facebook/pages" point has instagram_business_account_id field

    if (facebookIsConnected) {
      // Don't even try to get facebook pages if user is not connected to facebook
      dispatch(getFacebookPages())
    }
    dispatch(
      getAccessibleSocialPages({
        platform: FACEBOOK_PROVIDER_PLATFORM
      })
    )

    return () => {
      dispatch(clearFacebookPages())
      dispatch(clearAccessibleSocialPages())
    }
  }, [dispatch, facebookIsConnected])

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('Social Media Accounts')}</h3>
      <p>{t('Please select the social media profile to track')}</p>
      <Field
        placeholder={t('Social media page')}
        formik={formik}
        name={SOCIAL_MEDIA_POST}
        options={formattedFacebookPages}
        isLoading={accessibleSocialPagesIsLoading}
        isMulti={false}
        isSearchable={false}
      />
      {/*Don't show instagram account checkbox if user is not connected to facebook*/}
      {facebookIsConnected && <InstagramAccountCheckbox formik={formik} />}
    </section>
  )
}

export default SocialMediaAccountsSection
